export default {
      id: "chevron-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }